<template>
  <div>
    <h2 class="title is-5">
      <d-previous-btn
        :path="'/properties/' + $route.params.property"
        :before-click="beforeClick"
      />
      {{ $t("edit_property") }}
    </h2>

    <d-container
      v-if="model"
      style="max-width: 600px"
    >
      <v-form
        ref="form"
        action="edit"
        :model="model"
        @dirty="dirty = true"
      />
    </d-container>
  </div>
</template>

<script>
import form from "./_form.vue";

export default {
  metaInfo() {
    return {
      title: this.title,
      __property: this.title, // for breadcrumb
    };
  },
  components: {
    "v-form": form,
  },
  data() {
    return {
      model: null,
      loading: true,
      dirty: false,
    };
  },
  computed: {
    title() {
      if (this.model && this.model.address) {
        return this.model.address.full_address;
      }
      return "";
    },
  },
  watch: {
    "$route.params.property"() {
      this.fetch();
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    beforeClick(route) {
      if (!this.dirty) {
        this.$router.push(route);
      } else {
        this.$buefy.dialog.confirm({
          title: this.$t("leave_page_confirmation.title"),
          message: this.$t("leave_page_confirmation.message"),
          confirmText: this.$t("leave_page_confirmation.confirm"),
          cancelText: this.$t("leave_page_confirmation.cancel"),
          type: "is-warning",
          onConfirm: () => this.$router.push(route)
        });
      }
    },
    fetch() {
      this.loading = true;
      this.$http
        .get(
          this.$laravel.route("api.properties.show", {
            property: this.$route.params.property,
          })
        )
        .then((response) => {
          this.loading = false;
          this.model = response.data.data;
        })
        .catch((e) => {
          console.error(e);
          this.$router.push("/properties");
        });
    },
    submitForm() {
      this.$refs.form.$refs.form.submit();
    },
  },
};
</script>
